import { createSlice } from "@reduxjs/toolkit";
interface ToolSlice {
  view: string;
  types: any;
  toolsloading: boolean;
  tools: any;
  toolsloadingSearch: boolean;
  selectToolsTypes: any;
  searchTextInput: string;
  isDailogDetailTools: boolean;
  isDetailTools: any;
}
const initialState: ToolSlice = {
  view: "",
  types: [],
  toolsloading: false,
  tools: [],
  toolsloadingSearch: false,
  selectToolsTypes: "",
  searchTextInput: "",
  isDailogDetailTools: false,
  isDetailTools: {},
};
const toolSlice = createSlice({
  name: "tool",
  initialState,
  reducers: {
    setView(state, action) {
      state.view = action.payload;
    },
    setTypes(state, action) {
      state.types = action.payload;
    },
    setToolsloading(state, action) {
      state.toolsloading = action.payload;
    },
    setTools(state, action) {
      state.tools = action.payload;
    },
    setToolsloadingSearch(state, action) {
      state.toolsloadingSearch = action.payload;
    },
    setSelectToolsTypes(state, action) {
      state.selectToolsTypes = action.payload;
    },
    setSearchTextInput(state, action) {
      state.searchTextInput = action.payload;
    },
    setIsDailogDetailTools(state, action) {
      state.isDailogDetailTools = action.payload;
    },
    setIsDetailTools(state, action) {
      state.isDetailTools = action.payload;
    },
  },
});

export const { setTypes, setToolsloading, setTools, setToolsloadingSearch, setSelectToolsTypes, setSearchTextInput, setView, setIsDailogDetailTools, setIsDetailTools } =
  toolSlice.actions;
const toolSliceReducer = toolSlice.reducer;
export default toolSliceReducer;
